/**
 * @file: 层板对齐快捷方式
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as UIToolkit from '../../UIToolkit/index';
import FrontCubeData from '../../frontCubeData/index';
import CodiSystem from '../../codiSystem/index';
import Utils from '../../utils/util';
import Select from '../select/index';
import History from '../history/index';
import { cubeModify } from '../../update/cubeModify';
import { updateCubeList } from '../../update/updateCubeList';
import { updateEnd } from '../../update/updateEnd';
import { getCubeBeforeUpdateInfo } from '../../update/getCubeBeforeUpdateInfo';

interface ValidateResult {
    code: number,
    msg: string
};

function align(targets: CubeId[], dir: string): void {
    let layers: CubeId[] = CodiSystem.sortByLeft(targets);
    let updateList: CubeId[] = findUpdateTargets(layers);
    let updateTask: UpdateTask[] = makeUpdateTask(layers, dir);
    let beforeUpdateInfo: UpdateTask[] = getCubeBeforeUpdateInfo(updateTask);

    History.stackIn({
        type: 'layerAlign',
        data: beforeUpdateInfo
    });
    updateTask.forEach((updateTask: UpdateTask): void => {
        cubeModify(updateTask.cubeId, updateTask.updateData);
    });
    updateCubeList(updateList);
    updateEnd();
}

function alignTwoLayers(dir: string): void {
    let allSelected: Array<CubeId> = Select.getAll();
    let checkResult: ValidateResult = validate(allSelected);

    if (checkResult.code !== 0) {
        UIToolkit.tips(checkResult.msg);
        return;
    }

    align(allSelected, dir);
}

function makeUpdateTask(layers: CubeId[], dir: string): UpdateTask[] {
    let result: UpdateTask[] = [];
    let base: PhysicsCoordinate;

    if (dir === 'left') {
        base = CodiSystem.getPhysicsCoordinate(layers.shift());
    }
    else {
        base = CodiSystem.getPhysicsCoordinate(layers.pop());
    }
    let baseTop: PhysicsMeasurement = Utils.math(base.bottom, base.height, '+');

    layers.forEach((layer: CubeId): void => {
        let targetCoordinate: PhysicsCoordinate = CodiSystem.getPhysicsCoordinate(layer);

        result.push({
            cubeId: layer,
            updateData: {
                posY: Utils.math(baseTop, targetCoordinate.height, '-')
            }
        });
    });

    return result;
}

function validate(allSelected: CubeId[]): ValidateResult {
    if (!CubeTree.isPartitionList(allSelected)) {
        return {
            code: 1,
            msg: '该操作仅支持层板'
        };
    }

    if (!UIToolkit.layerInAdjoiningShelf(allSelected)) {
        return {
            code: 1,
            msg: '对齐层板必须在相邻货架内'
        };
    }

    return {
        code: 0,
        msg: ''
    };
}

function findUpdateTargets(cubeIds: CubeId[]): CubeId[] {
    let result: Set<CubeId> = new Set();

    cubeIds.forEach((cubeId: CubeId): void => {
        let itsShelf: CubeId = CubeTree.findCubeShelf(cubeId);

        result.add(itsShelf);
    });

    return Array.from(result);
}

export default {
    alignTwoLayers
};
